module.exports = __webpack_public_path__ + "img/power-plug-outline.e79bb8b5.svg";